import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700" }
const _hoisted_2 = { class: "flex items-start gap-2" }
const _hoisted_3 = { class: "font-medium text-gray-900" }

import { LockClosedIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'

import { franchiseLockText } from '@/helpers/franchiseManaged'


export default {
  __name: 'FranchiseLockNotice',
  props: {
  franchiseName: { type: String, default: null }
},
  setup(__props) {

const props = __props

const lockText = computed(() => franchiseLockText(props.franchiseName))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_unref(LockClosedIcon), {
        class: "mt-0.5 h-4 w-4 shrink-0 text-gray-500",
        "aria-hidden": "true"
      }),
      _createElementVNode("span", null, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(lockText.value) + ".", 1),
        _cache[0] || (_cache[0] = _createTextVNode(" Changes to this item are made on the franchise menu and synced here. ", -1))
      ])
    ])
  ]))
}
}

}